

















import { support, TicketParams } from '@/store/interfaces/tickets';
import Vue, { PropType } from 'vue';
import datesDescription from './datesDescription.vue';

export default Vue.extend({
  name: 'Support',
  components: {
    datesDescription,
  },
  props: {
    ticket: {
      type: Object as PropType<Omit<TicketParams, 'ticketable'> & { ticketable: support }>,
      required: true,
    },
  },
});
